export enum SupervisorPlaceStateEnum {
    "Transport commissioned" = 1,
    "At loading point" = 2,
    "Loaded" = 3,
    "At unloading point" = 4,
    "Unloaded" = 5,
    "Checkpoint" = 6
}
